import {Editor, Element, Transforms, type ImageElement} from "slate";

/**
 * Deletes the image note with the given URL at the current selection, if any.
 */
export const deleteImageNode = (editor: Editor, url: string) => {
    const [match] = Editor.nodes<ImageElement>(editor, {
        match: (n) =>
            !Editor.isEditor(n) &&
            Element.isElement(n) &&
            n.type === "image" &&
            n.url === url,
    });

    if (match) {
        Transforms.removeNodes(editor, {at: match[1]});
    }
};

/**
 * Updates the `url` property on the image at the current selection, if any.
 */
export const updateImageNode = (editor: Editor, newUrl: string) => {
    const [match] = Editor.nodes<ImageElement>(editor, {
        match: (n) =>
            !Editor.isEditor(n) && Element.isElement(n) && n.type === "image",
    });

    if (match) {
        Transforms.setNodes(editor, {url: newUrl}, {at: match[1]});
    }
};
